import { useEffect, useState } from 'react'
import type { FeatureMap } from '@gymboard/types'
import { screenApi } from '../lib/api'

const REFRESH_MS = 120_000

/**
 * The gym's per-feature on/off map for this screen. TVs run for days, so
 * it's polled: a feature switched off in Settings leaves the idle screen
 * within a couple of minutes. null until known — treat unknown as on (the
 * API refuses anything that's really off).
 */
export function useScreenFeatures(): FeatureMap | null {
  const [map, setMap] = useState<FeatureMap | null>(null)
  useEffect(() => {
    let cancelled = false
    const load = async () => {
      try {
        const res = await screenApi.getFeatures()
        if (!cancelled) setMap(res.data)
      } catch {
        // keep the last known map (or unknown)
      }
    }
    void load()
    const id = setInterval(load, REFRESH_MS)
    return () => {
      cancelled = true
      clearInterval(id)
    }
  }, [])
  return map
}

/** The API's 403 for a request that needs a switched-off feature. */
export const isFeatureDisabled = (err: unknown): boolean =>
  (err as { response?: { data?: { code?: string } } })?.response?.data?.code === 'FEATURE_DISABLED'
